module.exports = __webpack_public_path__ + "static/media/hardware.f8981aae.jpg";